// TODO: remove and use constants/devices.js instead
export default (() => {
    console.log('UNTUCKit : Module : IsMobile : loaded');
    let breakpoint = 1024;
    const check = function (minWidth) {
        breakpoint = typeof minWidth !== 'undefined' ? minWidth : breakpoint;
        if (window.innerWidth < breakpoint) {
            return true;
        }
        return false;
    };
    return {
        check
    };
})();
